
import React, { useEffect, useState } from 'react';
import '../Assets/Css/product.css';
import { Container, Row, Col, Button, Card, Image, Modal, Form, Spinner } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';

import erpsystem from '../Assets/Image/Erpsystem1.avif'
import crm from '../Assets/Image/crm2.avif'
import drp from '../Assets/Image/drp2.avif'
import hrm from '../Assets/Image/hrms1.avif'

import erp1 from '../Assets/Image/erpsystem2.avif'
import erp11 from '../Assets/Image/erpsystem3.avif'
import crm2 from '../Assets/Image/crm1.avif'
import crm22 from '../Assets/Image/crm3.avif'
import drp3 from '../Assets/Image/drp1.avif'
import drp33 from '../Assets/Image/drp3.avif'
import hrm4 from '../Assets/Image/hrms3.avif'
import hrm44 from '../Assets/Image/hrms2.avif'
import shopfloor from '../Assets/Image/shopfloor.jpg'
import shopfloor2 from '../Assets/Image/shopfloor1.avif'
import shopfloor3 from '../Assets/Image/shopfloor2.avif'
import production from '../Assets/Image/production3.avif'
import production2 from '../Assets/Image/Production1.avif'
import production3 from '../Assets/Image/production.avif'
import retailsell from '../Assets/Image/retailsell1.avif'
import retailsell2 from '../Assets/Image/retailsell.jpg'
import retailsell3 from '../Assets/Image/retailsell2.avif'

import aiTrading from '../Assets/Image/AItrading.avif'
import aiTrading2 from '../Assets/Image/AItrading2.avif'
import aiTrading3 from '../Assets/Image/AItrading3.avif'

import supportsystem from '../Assets/Image/supportsystem1.jpg'
import support2 from '../Assets/Image/support2.avif'
import support3 from '../Assets/Image/support3.avif'


import erpSuiteImage from '../Assets/Image/ctaproduct.avif'

import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import { BASE_URL } from '../BaseURL';
import '../Assets/Css/contact.css';

// testimonials
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { FaShoppingCart, FaEnvelopeOpenText } from 'react-icons/fa';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";

export default function About() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const testimonials = [
    "Trident Software Services transformed our workflow—efficient, intuitive, and scalable.",
    "Their team is not just tech-savvy, but also incredibly supportive and responsive.",
    "We’ve seen a 40% boost in productivity since implementing Trident’s ERP system.",
    "Professionalism and innovation define our experience with Trident. Highly recommended!",
    "From planning to execution, Trident delivered solutions that matched our business vision perfectly.",
  ];

  const products = [
    {
      title: "ERP System",
      text: "Enterprise Resource Planning system to streamline and scale your business operations.",
      description: "Enterprise Resource Planning (ERP) is a powerful software solution that integrates various business processes into a unified system. Our ERP System enables organizations to automate tasks, improve visibility across departments, reduce manual errors, and make data-driven decisions in real time. It’s scalable, customizable, and ideal for businesses seeking digital transformation and operational efficiency.",
      features: [
        "Centralized data management across departments",
        "Finance and accounting automation",
        "Human Resource Management (HRM)",
        "Inventory and supply chain tracking",
        "Customer Relationship Management (CRM)",
        "Sales and purchase order management",
        "Real-time analytics and reporting dashboards",
        "User role-based access and security controls",
        "Cloud-based and on-premise deployment options",
        "Mobile-friendly interface and multi-device support"
      ],
      image: erpsystem,
      alt: "ERP System Dashboard Interface",
      col: 3,
      relatedImages: [erpsystem, erp1, erp11]
    },


    {
      title: "CRM",
      text: "Customer Relationship Management system to enhance your client interactions.",
      description: "Our CRM solution helps businesses manage customer interactions, streamline sales processes, and improve customer satisfaction. With a focus on tracking leads, managing contacts, and automating marketing campaigns, this CRM empowers your sales and support teams to build stronger relationships and drive growth.",
      features: [
        "Contact and lead management",
        "Sales pipeline tracking",
        "Automated marketing campaigns",
        "Customer support ticketing",
        "Detailed reporting and analytics",
        "Integration with email and communication tools",
        "Customizable dashboards and workflows",
        "Mobile app for on-the-go access",
        "Role-based user permissions",
        "Seamless integration with ERP and other systems"
      ],
      image: crm,
      alt: "CRM Dashboard Interface",
      col: 3,
      relatedImages: [crm, crm2, crm22],
    }
    ,
    {
      title: "DRP",
      text: "Distribution Requirements Planning for optimized supply chain management.",
      description: "Our DRP (Distribution Requirements Planning) solution offers a comprehensive digital supply chain platform designed to optimize inventory levels, streamline distribution networks, and improve logistics efficiency. It provides real-time demand forecasting, inventory replenishment automation, and end-to-end visibility, enabling businesses to reduce costs, prevent stockouts, and enhance customer satisfaction.",
      features: [
        "Real-time inventory tracking and management",
        "Demand forecasting and planning",
        "Automated replenishment scheduling",
        "Optimized distribution network mapping",
        "Integration with ERP and warehouse management systems",
        "Route planning and logistics optimization",
        "Comprehensive reporting and analytics",
        "Multi-channel supply chain coordination",
        "Cloud-based access with mobile support",
        "Enhanced collaboration between suppliers and distributors"
      ],
      image: drp,
      alt: "Digital Supply Chain and Distribution Network",
      col: 3,
      relatedImages: [drp, drp3, drp33],
    }
    ,
    {
      title: "HRMS",
      text: "Human Resource Management System to streamline workforce administration.",
      description: "Our HRMS solution simplifies and automates HR processes including employee data management, payroll, attendance tracking, recruitment, and performance evaluation. It helps organizations improve employee engagement, ensure compliance, and make informed workforce decisions through powerful analytics and reporting tools.",
      features: [
        "Employee information and records management",
        "Payroll processing and tax management",
        "Attendance and leave tracking",
        "Recruitment and onboarding workflows",
        "Performance management and appraisals",
        "Training and development modules",
        "Compliance with labor laws and regulations",
        "Self-service portals for employees and managers",
        "Automated notifications and reminders",
        "Advanced analytics and customizable reports"
      ],
      image: hrm,
      alt: "HRMS Dashboard Interface",
      col: 3,
      relatedImages: [hrm, hrm4, hrm44],
    }
    ,
    {
      title: "Shopfloor Control",
      text: "Real-time production monitoring and control for manufacturing operations.",
      description: "Our Shopfloor Control system provides end-to-end visibility and management of production activities directly on the manufacturing floor. From tracking machine performance to managing work orders and labor, it empowers manufacturers to optimize workflows, reduce downtime, and improve production efficiency. With real-time data and integration with ERP systems, it ensures accurate planning, execution, and continuous improvement.",
      features: [
        "Real-time production tracking and monitoring",
        "Work order scheduling and progress updates",
        "Machine utilization and performance analysis",
        "Labor and shift management",
        "Downtime tracking and root cause analysis",
        "Integration with ERP, MES, and inventory systems",
        "Barcode and RFID-based data capture",
        "Quality control checkpoints and alerts",
        "Visual dashboards for line supervisors and managers",
        "Mobile and tablet access for floor operators"
      ],
      image: shopfloor,
      alt: "Shopfloor Control Dashboard",
      col: 3,
      relatedImages: [shopfloor, shopfloor2, shopfloor3],
    },
    {
      title: "Production Planning",
      text: "Optimize manufacturing efficiency with smart production planning tools.",
      description: "Our Production Planning system enables manufacturers to forecast demand, plan capacity, schedule production, and manage resources with precision. It aligns production schedules with customer orders, material availability, and shopfloor capacity—ensuring timely delivery, reduced waste, and balanced workloads. Designed to adapt to dynamic manufacturing environments, it enhances productivity, reduces bottlenecks, and improves overall operational control.",
      features: [
        "Demand forecasting and sales order alignment",
        "Material Requirement Planning (MRP)",
        "Capacity planning and load balancing",
        "Production scheduling and calendar management",
        "Work order generation and tracking",
        "Inventory and raw material availability checks",
        "Integration with ERP and shopfloor systems",
        "Scenario-based what-if planning",
        "Bottleneck identification and optimization",
        "Real-time visibility into production progress"
      ],
      image: production,
      alt: "Production Planning Dashboard",
      col: 3,
      relatedImages: [production, production2, production3],
    },
    {
      title: "Retail Sell",
      text: "Smart retail management for seamless in-store and online selling.",
      description: "Our Retail Sell solution is built to streamline point-of-sale operations, manage inventory in real-time, track customer preferences, and enable unified commerce across physical and digital channels. From billing to stock control and customer loyalty programs, it empowers retailers to enhance the shopping experience, improve efficiency, and grow revenue.",
      features: [
        "Point-of-Sale (POS) billing and checkout system",
        "Real-time inventory and stock tracking",
        "Multi-store and multi-location support",
        "Customer loyalty and rewards program integration",
        "Sales reporting and analytics dashboard",
        "Barcode and QR code scanning support",
        "Online and offline billing capability",
        "Role-based staff access and management",
        "Promotions, discounts, and coupon management",
        "Integration with accounting, e-commerce, and ERP systems"
      ],
      image: retailsell,
      alt: "Retail POS and Sales Dashboard",
      col: 3,
      relatedImages: [retailsell, retailsell2, retailsell3],
    },
    {
      title: "Support System",
      text: "Efficient customer support and ticket management made simple.",
      description: "Our Support System is designed to streamline customer service operations through efficient ticket handling, multichannel communication, and real-time response tracking. It empowers support teams to resolve issues faster, improve customer satisfaction, and maintain service quality across email, chat, phone, and social platforms—all in one centralized dashboard.",
      features: [
        "Ticket generation, assignment, and tracking",
        "Multi-channel support: email, chat, phone, and social media",
        "Automated responses and SLA-based escalation",
        "Knowledge base and self-service portal",
        "Customer history and interaction logs",
        "Custom ticket categories and status workflows",
        "Role-based user access and permissions",
        "Performance reporting and agent analytics",
        "Customer satisfaction (CSAT) feedback tools",
        "Seamless integration with CRM and ERP systems"
      ],
      image: supportsystem,
      alt: "Customer Support Dashboard",
      col: 3,
      relatedImages: [supportsystem, support2, support3],
    },
    {
      title: "AI Trading",
      text: "Advanced AI-powered trading platform for smarter investment decisions.",
      description: "Our AI Trading system leverages cutting-edge artificial intelligence and machine learning algorithms to analyze market trends, predict price movements, and execute trades automatically. It helps traders and investors maximize returns by making data-driven decisions in real time, minimizing risks, and optimizing portfolio management with minimal manual intervention.",
      features: [
        "Real-time market data analysis and forecasting",
        "Automated trade execution with customizable strategies",
        "Risk management and stop-loss automation",
        "Backtesting tools for strategy validation",
        "Portfolio optimization and diversification",
        "Integration with multiple stock and crypto exchanges",
        "User-friendly dashboards with detailed performance metrics",
        "Mobile app for trading on the go",
        "Secure, encrypted data handling and user authentication",
        "Continuous learning algorithms adapting to market changes"
      ],
      image: aiTrading, // replace with your actual imported AI Trading image variable
      alt: "AI Trading Platform Dashboard",
      col: 3,
      relatedImages: [aiTrading, aiTrading2, aiTrading3] // replace with your related images variables
    }
  ];


  const [showModal, setShowModal] = useState(false);
  const [selectedFlavor, setSelectedFlavor] = useState(null);
  const [mainImage, setMainImage] = useState(null);

  const handleOpenModal = (flavor) => {
    setSelectedFlavor(flavor);
    setMainImage(flavor.image); // default main image
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedFlavor(null);
    setMainImage(null);
  };

  const [showInquiryModal, setShowInquiryModal] = useState(false);
  const handleOpenInquiryModal = () => {
    setShowModal(false); // close the detail modal
    setShowInquiryModal(true); // open the inquiry modal
  };

  const [form, setForm] = useState({

    userName: "",
    mobile: "",
    email: "",
    address: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        productName: selectedFlavor.title,

        ...form
      };
      await axios.post(`${BASE_URL}/enquiry/sendProductEnquiry`, payload);
      toast.success("Product Inquiry sent successfully!");

      // ✅ Clear the form after submission
      setForm({

        userName: '',
        mobile: '',
        email: '',
        address: '',
        message: ''
      });

      // ✅ Close the modal
      setShowInquiryModal(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to send inquiry.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Toaster />
      <div style={{ minHeight: '100vh' }}>
        <Helmet>
          {/* Primary Meta Tags */}
          <title>Products & Training | Trident Software Services</title>
          <meta
            name="description"
            content="Explore Trident's cutting-edge software products and in-depth training programs designed to enhance productivity, efficiency, and innovation for businesses of all sizes."
          />
          <meta
            name="keywords"
            content="Trident software products, IT training, business software, enterprise tools, technical training, digital solutions, software for startups"
          />
          <meta name="author" content="Trident Software Services" />

          {/* Open Graph / Facebook */}
          <meta property="og:title" content="Products & Training | Trident Software Services" />
          <meta
            property="og:description"
            content="Discover robust business software and expert-led training from Trident. Built for startups, enterprises, and consultants aiming to scale intelligently."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tridentsoftwaresolutions.com/products" />
          <meta
            property="og:image"
            content="https://tridentsoftwaresolutions.com/images/products-training-banner.jpg"
          />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Products & Training | Trident Software Services" />
          <meta
            name="twitter:description"
            content="Trident offers scalable software products and hands-on training that empower businesses and individuals to thrive in the digital age."
          />
          <meta
            name="twitter:image"
            content="https://tridentsoftwaresolutions.com/images/products-training-banner.jpg"
          />

          {/* Canonical URL */}
          <link rel="canonical" href="https://tridentsoftwaresolutions.com/products" />
        </Helmet>

        {/* Banner Section */}
        <div className="banner3-section d-flex align-items-center justify-content-center">
          <div className="banner3-overlay text-center" data-aos="zoom-in">
            <h2 className="banner1-title">Transforming Enterprises with Intelligent, Scalable Solutions</h2>
            <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
              Powering business growth through smart, streamlined, and scalable Software Services.
            </p>
          </div>
        </div>

        <section className='py-5 productback '  >
          <Container>
            <Row className="text-center section-heading" data-aos="zoom-in" data-aos-delay="200">
              <Col>
                <h3 className="fw-bold section-title">
                  Our Products
                  <span className="title-decoration"> </span>
                </h3>
                <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                  Our products are designed to simplify operations, boost efficiency, and drive digital growth across your business.
                </p>
              </Col>
            </Row>

            <Row className="g-3" data-aos="fade-up" data-aos-delay="100">
              {products.map((flavor, index) => (
                <Col key={index} md={flavor.col} xs={12} className="mb-4">
                  <div className="flavor-tile position-relative overflow-hidden  shadow-lg">
                    <Image
                      src={flavor.image}
                      alt={flavor.alt}
                      fluid
                      className="w-100 flavorproduct-img"
                    />
                    <div className=" mt-3 mb-3">
                      <h6 className="text-center fw-bold" style={{ color: '#870a19' }}>{flavor.title}</h6>
                    </div>
                    <div className="mb-3 d-flex justify-content-center">
                      <Button variant="light" className='viewbutton' size="sm" onClick={() => handleOpenModal(flavor)}>
                        View Details <MdKeyboardDoubleArrowRight size={18} />
                      </Button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Modal Section */}
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          size="lg"
          aria-labelledby="flavor-details-modal"
          centered
          className='my-3 mb-3 '
        >
          {selectedFlavor && (
            <>
              <Modal.Header closeButton onHide={handleCloseModal} />
              <Modal.Body>
                <Row>
                  <Col md={5} className="text-center">
                    <Image src={mainImage} alt={selectedFlavor.alt} className='flvorimgemodal' fluid rounded />
                    <Row className="mt-3 justify-content-center">
                      {selectedFlavor.relatedImages.map((img, idx) => (
                        <Col xs={4} key={idx} className="mb-2">
                          <Image
                            src={img}
                            alt={`Related ${idx + 1}`}
                            fluid
                            rounded
                            className="related-image"
                            style={{ cursor: 'pointer', border: img === mainImage ? '2px solid #870a19' : 'none' }}
                            onClick={() => setMainImage(img)}
                          />
                        </Col>
                      ))}
                    </Row>
                  </Col>

                  <Col md={7} className='scrollable-col'>
                    <h4 className="fw-bold " style={{ color: '#870a19' }}>{selectedFlavor.title}</h4>
                    <p>{selectedFlavor.text}</p>

                    {/* Additional Description */}
                    {selectedFlavor.description && (
                      <>
                        <h6 style={{ color: '#bb606e', fontWeight: 'bold' }}>Description:</h6>
                        <p>{selectedFlavor.description}</p>
                      </>
                    )}


                    {selectedFlavor.features && (
                      <>
                        <h6 style={{ color: '#430001', fontWeight: 'bold' }}>Features:</h6>
                        <ul style={{ paddingLeft: '1.2rem' }}>
                          {selectedFlavor.features.map((feature, index) => (
                            <li key={index}>{feature}</li>
                          ))}
                        </ul>
                      </>
                    )}

                    <div className="d-flex  ">
                      <Button
                        variant="light"
                        size="md"
                        className="text-white donatemodalbutton p-2"
                        onClick={() =>
                          toast.success('🛒 Add to Cart feature is coming soon!', {
                            style: {
                              borderRadius: '8px',
                              background: '#d4edda',
                              color: '#155724',
                              border: '1px solid #c3e6cb',
                              padding: '12px 16px',
                              fontWeight: '500',
                            },
                            icon: '✅',
                            duration: 2000,
                          })
                        }
                      >
                        <FaShoppingCart className="me-2" />
                        Add to Cart
                      </Button>



                      <Button
                        variant="light"
                        size="md"
                        className=" donatemodalbutton "
                        onClick={handleOpenInquiryModal}>
                        <FaEnvelopeOpenText className="me-2" />
                        Inquiry
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
            </>
          )}
        </Modal>



        {/* <Modal className='my-3' show={showInquiryModal} onHide={() => setShowInquiryModal(false)} size="lg" centered>
          {selectedFlavor && (
            <>
              <Modal.Header closeButton className="position-relative justify-content-center " style={{ backgroundColor: '#f3e2e5' }}>
                <div className="w-100 text-center">
                  <Modal.Title className="mx-auto" style={{ color: '#870a19', fontWeight: 'bold' }}>
                    Product Inquiry
                  </Modal.Title>
                </div>
              </Modal.Header>

              <Modal.Body>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className='fw-bold'>Product Name</Form.Label>
                        <Form.Control readOnly value={selectedFlavor.title}
                          style={{ color: '#870a19', fontWeight: 'bold' }} />
                      </Form.Group>
                    </Col>

                  </Row>

                  <Row>

                    <Col md={6} className='fw-bold'>
                      <Form.Group className="mb-3">
                        <Form.Label>Your Name</Form.Label>
                        <Form.Control name="userName" type="text"
                          value={form.userName} onChange={handleChange}
                          placeholder="Enter your full name"
                          required />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className='fw-bold'>Email</Form.Label>
                        <Form.Control name="email" type="email"
                          value={form.email} onChange={handleChange}
                          placeholder="Enter your email"
                          required />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className='fw-bold'>Mobile Number</Form.Label>
                        <Form.Control name="mobile" type="tel" maxLength={10}
                          value={form.mobile} onChange={handleChange}
                          placeholder="Enter your Mob Number"
                          required />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className='fw-bold'>Address</Form.Label>
                        <Form.Control name="address" type="address"
                          value={form.address} onChange={handleChange}
                          placeholder="Enter your address"
                          required />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label className='fw-bold'>Message</Form.Label>
                    <Form.Control name="message" as="textarea" rows={3}
                      value={form.message}
                      onChange={handleChange}
                      placeholder="Enter message"
                    />
                  </Form.Group>


                  <Button variant="primary" type="submit" className="donatemodalbutton" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner size="sm" animation="border" className="me-2" />
                        Sending Inquiry...
                      </>
                    ) : (
                      "Send Inquiry"
                    )}
                  </Button>
                </Form>
              </Modal.Body>
            </>
          )}
        </Modal> */}

        <Modal className="my-3" show={showInquiryModal} onHide={() => setShowInquiryModal(false)} size="lg" centered>
          {selectedFlavor && (
            <>
              <Modal.Header
                closeButton
                className="position-relative justify-content-center"
                style={{ backgroundColor: '#f3e2e5' }}
              >
                <div className="w-100 text-center">
                  <Modal.Title className="mx-auto" style={{ color: '#870a19', fontWeight: 'bold' }}>
                    Product Inquiry
                  </Modal.Title>
                </div>
              </Modal.Header>

              <Modal.Body>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Product Name</Form.Label>
                        <Form.Control
                          readOnly
                          value={selectedFlavor.title}
                          style={{ color: '#870a19', fontWeight: 'bold' }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6} className="fw-bold">
                      <Form.Group className="mb-3">
                        <Form.Label>Your Name</Form.Label>
                        <Form.Control
                          name="userName"
                          type="text"
                          value={form.userName}
                          onChange={handleChange}
                          placeholder="Enter your full name"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Email</Form.Label>
                        <Form.Control
                          name="email"
                          type="email"
                          value={form.email}
                          onChange={handleChange}
                          placeholder="Enter your email"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Mobile Number</Form.Label>
                        <Form.Control
                          name="mobile"
                          type="tel"
                          maxLength={10}
                          value={form.mobile}
                          onChange={handleChange}
                          placeholder="Enter your Mob Number"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Address</Form.Label>
                        <Form.Control
                          name="address"
                          type="text"
                          value={form.address}
                          onChange={handleChange}
                          placeholder="Enter your address"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">Message</Form.Label>
                    <Form.Control
                      name="message"
                      as="textarea"
                      rows={3}
                      value={form.message}
                      onChange={handleChange}
                      placeholder="Enter message"
                    />
                  </Form.Group>

                  <Button variant="primary" type="submit" className="donatemodalbutton" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner size="sm" animation="border" className="me-2" />
                        Sending Inquiry...
                      </>
                    ) : (
                      "Send Inquiry"
                    )}
                  </Button>
                </Form>
              </Modal.Body>
            </>
          )}
        </Modal>



        <section style={{ backgroundColor: "#fffaf5", padding: "60px 0" }}>
          <Container>
            <Row className="text-center section-heading" data-aos="zoom-in" data-aos-delay="200">
              <Col>
                <h3 className="fw-bold section-title">
                  Product Training
                  <span className="title-decoration"> </span>
                </h3>
                <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                  Expert-led training to help your team quickly adopt and use our products with confidence and ease.
                </p>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={10} style={{ textAlign: 'justify' }}>

                <p style={{ fontSize: "1.1rem" }}>
                  We understand that the successful implementation of any digital solution relies not only on great software,
                  but also on the ability of your team to use it confidently and effectively. That’s why we offer a structured
                  and in-depth training program tailored to your business needs and user roles. Whether you're adopting our ERP,
                  CRM, HRMS, DRP, Shopfloor Control, Production Planning, Retail Sell, or Support System, our training ensures
                  every stakeholder—admin, team lead, or end-user—gets onboarded seamlessly.
                </p>

                <p style={{ fontSize: "1.1rem" }}>
                  The training includes live sessions with product experts, role-specific walkthroughs, real-world use-case
                  simulations, and hands-on exercises. We cover everything from system setup, data entry workflows, automation
                  features, to advanced analytics and reporting tools. For each module, we provide user manuals, video tutorials,
                  and access to a self-service knowledge base to support ongoing learning.
                </p>

                <p style={{ fontSize: "1.1rem" }}>
                  Additionally, post-implementation support is included to assist your team in real scenarios as they begin
                  using the system. We also conduct regular refresher sessions, onboarding for new employees, and help you
                  track adoption progress using usage analytics. Our goal is to not only teach your team how to use the system,
                  but to empower them to make better, faster, and smarter decisions every day using the tools we provide.
                </p>

                <p style={{ fontSize: "1.1rem" }}>
                  Whether you're a small team or a large enterprise, our training and onboarding approach is scalable, flexible,
                  and focused on real outcomes. It’s your path to full digital adoption, higher ROI, and long-term success.
                </p>
              </Col>
            </Row>
          </Container>
        </section>


        <section
          className="cta-section py-5"
          style={{ backgroundColor: '#430001', color: 'white' }}

        >
          <Container>
            <Row className="align-items-center">
              <Col md={6} className="mb-4 mb-md-0 text-center">
                <Image
                  src={erpSuiteImage}
                  alt="Integrated Business Software Suite"
                  fluid
                  data-aos="zoom-in"
                  style={{ borderRadius: '8px', width: '100%', height: '350px', objectFit: 'fill' }}
                />
              </Col>
              <Col md={6} data-aos="zoom-in">
                <h2 className="mb-3">Streamline Your Business Operations with Our Integrated Solutions</h2>
                <p style={{ fontSize: '1.1rem', lineHeight: 1.5 }}>
                  From ERP and CRM to HRMS and Supply Chain Management, our product suite empowers your organization to improve efficiency, automate processes, and drive digital transformation — all in one platform.
                </p>
                <div className="d-flex justify-content-center mt-3">
                  <Button
                    variant="light"
                    size="md"
                    href="/contact"
                    className="donatemodalbutton mt-4"
                  >
                    Get in Touch
                  </Button>
                </div>

              </Col>
            </Row>
          </Container>
        </section>

        <section className="testimonial-carousel-section my-5">
          <div className="container py-3 ">
            <Row className="align-items-center justify-content-center flex-md-row m-0">
              <h3 className="fw-bold text-center section-title">
                Empowering Innovation Through Experience
                <span className="title-decoration mb-2"></span>
              </h3>
              <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                Hear what our clients say about transforming their business with Trident Software Services.
              </p>
              <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

                <Swiper
                  modules={[Autoplay, Pagination, Navigation]}
                  spaceBetween={30}
                  loop={true}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  pagination={{ clickable: true }}
                  navigation={true}
                  className="testimonial-swiper"
                >
                  {testimonials.map((text, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="stars mb-1">
                        {[...Array(5)].map((_, i) => (
                          <FaStar key={i} color="#d23f57" />
                        ))}
                      </div>
                      <p className="testimonial-quote">
                        <span className="quote-mark">“</span>
                        {text}
                        <span className="quote-mark">”</span>
                      </p>
                      <p className="author-name">Anonymous</p>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </div>
        </section>

      </div>
    </>
  );
}
